<template>
    <div class="week_calendar_wrap">
        <div class="calendar_date">
            <span>{{
                currentStartYear == currentEndYear
                    ? `${currentStartYear}年 ${currentStartDateText}-${currentendDateText}`
                    : `${currentStartDate}至${currentendDate}`
            }}</span>
        </div>

        <!-- 左右滑动事件 -->
        <v-touch @swipeleft="onSwipeLeft" @swiperight="onSwipeRight" tag="div">
            <div @touchmove="handleTouchMove" class="weekBox">
                <span
                    v-for="(week, index) in weeks"
                    :key="index"
                    @click="changeWeekFun(index)"
                    :class="currentIndex === index ? 'itemSty active' : 'itemSty'"
                >
                    第{{ index + 1 }}周</span
                >
            </div>
        </v-touch>
    </div>
</template>

<script>
export default {
    name: "WeekCalendar",
    data() {
        return {
            weeks: [], // 存储每周的开始和结束日期
            year: "",
            month: "",
            currentIndex: 0,

            currentStartYear: "",
            currentEndYear: "",

            currentStartDate: "",
            currentendDate: "",

            currentStartDateText: "",
            currentendDateText: "",
        };
    },
    mounted() {
        // 示例：计算2025年2月的周数及每周日期范围
        var currentDate = new Date();
        var currentYear = currentDate.getFullYear();
        var currentMonth = currentDate.getMonth(); // 月份从0开始，所以要加
        const year = currentYear;
        const month = currentMonth; // 2月（月份从0开始）
        const weeks = this.getWeeksInMonth(year, month);
        const day = currentDate.getDate();
        this.year = year;
        this.month = month;
        this.currentIndex = this.getWeekOfMonth() - 1;
        this.weeks = weeks;
        this.getCurrentDate(this.currentIndex);
    },
    methods: {
        getCurrentDate(currentIndex, type) {
            let weeks = this.weeks;

            this.currentStartYear = weeks[currentIndex].start.year;
            this.currentEndYear = weeks[currentIndex].end.year;
            this.currentStartDateText = weeks[currentIndex].start.month + "." + weeks[currentIndex].start.day;
            this.currentendDateText = weeks[currentIndex].end.month + "." + weeks[currentIndex].end.day;

            this.currentStartDate =
                weeks[currentIndex].start.year +
                "-" +
                weeks[currentIndex].start.month +
                "-" +
                weeks[currentIndex].start.day;
            this.currentendDate =
                weeks[currentIndex].end.year + "-" + weeks[currentIndex].end.month + "-" + weeks[currentIndex].end.day;
            if (!type || type !== "swipe") {
                this.$emit("week-change", this.currentStartDate, this.currentendDate);
            }
        },
        // 辅助函数：获取日期所在周的周一
        getMonday(date) {
            const d = new Date(date);
            const day = d.getDay(); // 0（周日）到 6（周六）
            const diff = day === 0 ? 6 : day - 1; // 计算到上周一的差值
            d.setDate(d.getDate() - diff);
            d.setHours(0, 0, 0, 0); // 清除时间部分
            return d;
        },
        getWeekOfMonth() {
            // 获取当前日期的周一
            const currentDate = new Date();
            const currentMonday = this.getMonday(currentDate);

            // 获取当前月的第一天和最后一天
            const year = currentDate.getFullYear();
            const month = currentDate.getMonth();
            const firstDay = new Date(year, month, 1);
            const lastDay = new Date(year, month + 1, 0);

            // 计算当前月的第一个周一（可能在上个月）
            const firstMonday = this.getMonday(firstDay);
            // 计算当前月的最后一个周一（可能在次月）
            const lastMonday = this.getMonday(lastDay);

            // 生成当前月所有周一的列表（覆盖跨月情况）
            const mondays = [];
            let monday = new Date(firstMonday);
            while (monday <= lastMonday) {
                mondays.push(new Date(monday));
                monday.setDate(monday.getDate() + 7);
            }

            // 查找当前周一在列表中的位置（索引 +1 即为周数）
            const weekNumber = mondays.findIndex((m) => m.getTime() === currentMonday.getTime()) + 1;

            return weekNumber;
        },
        /**
         * 获取一个月的周数及每周的日期范围
         * @param {number} year - 年份（如 2025）
         * @param {number} month - 月份（0-11，0表示1月）
         * @returns {Array} - 返回一个数组，每个元素为每周的日期范围（包含年、月、日）
         */
        getWeeksInMonth(year, month) {
            // 获取该月的第一天
            const firstDayOfMonth = new Date(year, month, 1);
            // 获取该月最后一天
            const lastDayOfMonth = new Date(year, month + 1, 0);

            // 获取该月第一天是星期几（0=周日，1=周一，...，6=周六）
            const firstDayOfWeek = firstDayOfMonth.getDay();
            // 获取该月的总天数
            const totalDays = lastDayOfMonth.getDate();

            // 计算第一周的起始日期
            let startDate = 1;
            if (firstDayOfWeek !== 1) {
                // 如果第一天不是周一，则第一周从上一个周一开始
                startDate -= (firstDayOfWeek - 1 + 7) % 7;
            }

            // 存储每周的日期范围
            const weeks = [];
            while (startDate <= totalDays) {
                const weekStart = new Date(year, month, Math.max(startDate)); // 确保不小于1
                const weekEnd = new Date(year, month, Math.min(startDate + 6, totalDays)); // 确保不超过总天数

                // 将日期范围格式化为年月日
                const weekRange = {
                    start: {
                        year: weekStart.getFullYear(),
                        month: weekStart.getMonth() + 1,
                        day: weekStart.getDate(),
                    },
                    end: {
                        year: weekEnd.getFullYear(),
                        month: weekEnd.getMonth() + 1,
                        day: weekEnd.getDate(),
                    },
                };
                weeks.push(weekRange);

                startDate += 7; // 跳到下一周
            }

            return weeks;
        },
        changeWeekFun(index) {
            this.currentIndex = index;
            let currentIndex = this.currentIndex;
            let weeks = this.weeks;

            this.currentStartYear = weeks[currentIndex].start.year;
            this.currentEndYear = weeks[currentIndex].end.year;
            this.currentStartDateText = weeks[currentIndex].start.month + "." + weeks[currentIndex].start.day;
            this.currentendDateText = weeks[currentIndex].end.month + "." + weeks[currentIndex].end.day;

            this.currentStartDate =
                weeks[currentIndex].start.year +
                "-" +
                weeks[currentIndex].start.month +
                "-" +
                weeks[currentIndex].start.day;
            this.currentendDate =
                weeks[currentIndex].end.year + "-" + weeks[currentIndex].end.month + "-" + weeks[currentIndex].end.day;

            this.$emit("week-change", this.currentStartDate, this.currentendDate);
        },
        //左滑 下一个
        onSwipeLeft() {
            let status = this.isDateGreaterThanToday(this.year, this.month);
            if (status) {
                return;
            }

            this.month++;
            if (this.month >= 12) {
                this.month = 0;
                this.year++;
            }
            const weeks = this.getWeeksInMonth(this.year, this.month);
            this.weeks = weeks;
            let l = this.weeks.length;
            if (this.currentIndex + 1 > l) {
                this.currentIndex = l - 1;
            }
            this.getCurrentDate(this.currentIndex, "swipe");
        },
        //右滑 上一个
        onSwipeRight() {
            if (this.month <= 0) {
                this.month = 12;
                this.year--;
            }
            this.month--;
            const weeks = this.getWeeksInMonth(this.year, this.month);
            this.weeks = weeks;
            let l = this.weeks.length;
            if (this.currentIndex + 1 > l) {
                this.currentIndex = l - 1;
            }
            this.getCurrentDate(this.currentIndex, "swipe");
        },
        isDateGreaterThanToday(year, month) {
            var currentDate = new Date();
            var currentYear = currentDate.getFullYear();
            var currentMonth = currentDate.getMonth() + 1; // 月份从0开始，所以要加
            if (year > currentYear) {
                return true;
            } else if (year == currentYear) {
                if (month + 1 >= currentMonth) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },

        handleTouchMove(event) {
            const scrollableContent = event.currentTarget;
            const isScrollable = scrollableContent.scrollWidth > scrollableContent.clientWidth; // 判断是否需要滚动
            if (!isScrollable) {
                event.preventDefault(); // 阻止默认行为，让外层 v-touch 触发
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.week_calendar_wrap {
    padding: 12px 24px;
    .calendar_date {
        display: flex;
        justify-content: space-between;
        span:nth-child(1) {
            font-size: 16px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 24px;
            color: rgba(51, 51, 51, 1);
        }
    }
}
.weekBox {
    // white-space: nowrap;
    // width: 1000px;
    // overflow-x: auto;
    .itemSty {
        display: inline-block;
        vertical-align: top;
        width: 64px;
        height: 24px;
        opacity: 1;
        text-align: center;
        line-height: 24px;

        font-size: 12px;
        font-weight: 400;
        letter-spacing: 0px;
        color: rgba(102, 102, 102, 1);
        border-radius: 12px;
        background: rgba(243, 243, 243, 1);
        margin-right: 8px;
        margin-top: 10px;
        &.active {
            color: rgba(25, 144, 255, 1);
            background: rgba(25, 144, 255, 0.16);
        }
    }
}
</style>
